import logo from "../../images/newme.png"


export default function MePic() {
  return (
    <img className="me-pic" src={logo} alt="me logo" />
   
  );
}